__turbopack_context__.v({
  "button": "HzBJzW_button",
  "calculator": "HzBJzW_calculator",
  "inputs": "HzBJzW_inputs",
  "nonZero": "HzBJzW_nonZero",
  "outputs": "HzBJzW_outputs",
  "result": "HzBJzW_result",
  "results": "HzBJzW_results",
  "title": "HzBJzW_title",
});
